// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ETQJ","image":"Header_image__1EsBa","name":"Header_name__2A9rB","info":"Header_info__2VsXV","infoRow":"Header_infoRow__pXZX8"};